/* eslint-disable react/prop-types */
import React from 'react';

export const WishlistIcon = ({ width = '80', height = '70' }) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 80 60`}>
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C8.3 10 11.6 10 15 10 C15 11.65 15 13.3 15 15 C18.3 15 21.6 15 25 15 C25 16.65 25 18.3 25 20 C28.3 20 31.6 20 35 20 C35 18.35 35 16.7 35 15 C36.65 15 38.3 15 40 15 C40 13.35 40 11.7 40 10 C43.3 10 46.6 10 50 10 C50 11.65 50 13.3 50 15 C51.65 15 53.3 15 55 15 C55 21.6 55 28.2 55 35 C56.65 35 58.3 35 60 35 C60 36.65 60 38.3 60 40 C61.65 40 63.3 40 65 40 C65 43.3 65 46.6 65 50 C60.05 50 55.1 50 50 50 C50 54.95 50 59.9 50 65 C48.35 65 46.7 65 45 65 C45 66.65 45 68.3 45 70 C43.35 70 41.7 70 40 70 C40 68.35 40 66.7 40 65 C38.35 65 36.7 65 35 65 C35 63.35 35 61.7 35 60 C33.35 60 31.7 60 30 60 C30 58.35 30 56.7 30 55 C21.75 55 13.5 55 5 55 C5 51.7 5 48.4 5 45 C6.65 45 8.3 45 10 45 C10 43.35 10 41.7 10 40 C11.65 40 13.3 40 15 40 C15 36.7 15 33.4 15 30 C13.35 30 11.7 30 10 30 C10 25.05 10 20.1 10 15 C8.35 15 6.7 15 5 15 C5 18.3 5 21.6 5 25 C3.35 25 1.7 25 0 25 C0 21.7 0 18.4 0 15 C-3.3 15 -6.6 15 -10 15 C-10 13.35 -10 11.7 -10 10 C-6.7 10 -3.4 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#FFE63F"
        transform="translate(15,0)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C11.65 5 13.3 5 15 5 C15 11.6 15 18.2 15 25 C16.65 25 18.3 25 20 25 C20 26.65 20 28.3 20 30 C21.65 30 23.3 30 25 30 C25 33.3 25 36.6 25 40 C20.05 40 15.1 40 10 40 C10 44.95 10 49.9 10 55 C8.35 55 6.7 55 5 55 C5 56.65 5 58.3 5 60 C3.35 60 1.7 60 0 60 C0 58.35 0 56.7 0 55 C-1.65 55 -3.3 55 -5 55 C-5 48.4 -5 41.8 -5 35 C-3.35 35 -1.7 35 0 35 C0 38.3 0 41.6 0 45 C1.65 45 3.3 45 5 45 C5 38.4 5 31.8 5 25 C3.35 25 1.7 25 0 25 C0 21.7 0 18.4 0 15 C-4.95 15 -9.9 15 -15 15 C-15 13.35 -15 11.7 -15 10 C-11.7 10 -8.4 10 -5 10 C-5 8.35 -5 6.7 -5 5 C-3.35 5 -1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF7C5"
        transform="translate(55,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C6.65 10 8.3 10 10 10 C10 8.35 10 6.7 10 5 C11.65 5 13.3 5 15 5 C15 9.95 15 14.9 15 20 C13.35 20 11.7 20 10 20 C10 21.65 10 23.3 10 25 C8.35 25 6.7 25 5 25 C5 23.35 5 21.7 5 20 C3.35 20 1.7 20 0 20 C0 13.4 0 6.8 0 0 Z "
        fill="#FFE539"
        transform="translate(50,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C8.3 10 11.6 10 15 10 C15 11.65 15 13.3 15 15 C11.7 15 8.4 15 5 15 C5 18.3 5 21.6 5 25 C3.35 25 1.7 25 0 25 C0 21.7 0 18.4 0 15 C-3.3 15 -6.6 15 -10 15 C-10 13.35 -10 11.7 -10 10 C-6.7 10 -3.4 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#FFF8C8"
        transform="translate(15,0)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 3.3 20 6.6 20 10 C13.4 10 6.8 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#FFF086"
        transform="translate(60,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C6.65 10 8.3 10 10 10 C10 16.6 10 23.2 10 30 C8.35 30 6.7 30 5 30 C5 26.7 5 23.4 5 20 C3.35 20 1.7 20 0 20 C0 13.4 0 6.8 0 0 Z "
        fill="#FFEB63"
        transform="translate(50,25)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C11.6 5 18.2 5 25 5 C25 6.65 25 8.3 25 10 C16.75 10 8.5 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#986033"
        transform="translate(20,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C6.65 5 8.3 5 10 5 C10 6.65 10 8.3 10 10 C8.35 10 6.7 10 5 10 C5 11.65 5 13.3 5 15 C3.35 15 1.7 15 0 15 C0 13.35 0 11.7 0 10 C-1.65 10 -3.3 10 -5 10 C-5 8.35 -5 6.7 -5 5 C-3.35 5 -1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFFBE3"
        transform="translate(5,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C6.65 5 8.3 5 10 5 C10 6.65 10 8.3 10 10 C3.4 10 -3.2 10 -10 10 C-10 8.35 -10 6.7 -10 5 C-6.7 5 -3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF194"
        transform="translate(35,40)"
      />
      <path
        d="M0 0 C4.95 0 9.9 0 15 0 C15 1.65 15 3.3 15 5 C11.7 5 8.4 5 5 5 C5 8.3 5 11.6 5 15 C3.35 15 1.7 15 0 15 C0 10.05 0 5.1 0 0 Z "
        fill="#986033"
        transform="translate(25,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C0.05 10 -4.9 10 -10 10 C-10 8.35 -10 6.7 -10 5 C-6.7 5 -3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#986033"
        transform="translate(75,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 4.95 5 9.9 5 15 C1.7 15 -1.6 15 -5 15 C-5 13.35 -5 11.7 -5 10 C-3.35 10 -1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#FFF3A1"
        transform="translate(30,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C0.05 10 -4.9 10 -10 10 C-10 8.35 -10 6.7 -10 5 C-6.7 5 -3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF5B8"
        transform="translate(50,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 6.6 5 13.2 5 20 C3.35 20 1.7 20 0 20 C0 13.4 0 6.8 0 0 Z "
        fill="#986033"
        transform="translate(65,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 4.95 5 9.9 5 15 C3.35 15 1.7 15 0 15 C0 10.05 0 5.1 0 0 Z "
        fill="#986033"
        transform="translate(60,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#FFE645"
        transform="translate(55,45)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF6B8"
        transform="translate(25,45)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF7C4"
        transform="translate(65,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#FFF086"
        transform="translate(50,25)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#FFEA5C"
        transform="translate(45,25)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#986033"
        transform="translate(30,30)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#986033"
        transform="translate(40,20)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#986033"
        transform="translate(55,10)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF8C8"
        transform="translate(5,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#FFF8C8"
        transform="translate(15,0)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#986033"
        transform="translate(55,65)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFE745"
        transform="translate(55,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#986033"
        transform="translate(50,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFFFFF"
        transform="translate(25,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFE84F"
        transform="translate(50,55)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#986033"
        transform="translate(45,55)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFEA5C"
        transform="translate(45,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF8C8"
        transform="translate(10,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF8C8"
        transform="translate(0,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFEA5C"
        transform="translate(55,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFEB6A"
        transform="translate(40,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF8C8"
        transform="translate(25,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF8C8"
        transform="translate(5,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF3A1"
        transform="translate(60,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFE850"
        transform="translate(40,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFEE77"
        transform="translate(35,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#986033"
        transform="translate(25,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#986033"
        transform="translate(70,35)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF193"
        transform="translate(55,35)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFEC69"
        transform="translate(50,35)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFEA5C"
        transform="translate(35,35)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF4AE"
        transform="translate(55,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF2A1"
        transform="translate(50,25)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFED78"
        transform="translate(45,25)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFE850"
        transform="translate(40,25)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFE535"
        transform="translate(35,25)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFE950"
        transform="translate(30,25)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFE535"
        transform="translate(15,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#986033"
        transform="translate(50,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFF8C8"
        transform="translate(15,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFE535"
        transform="translate(25,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFFFFF"
        transform="translate(15,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFE535"
        transform="translate(5,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFFFFF"
        transform="translate(55,0)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#FFE535"
        transform="translate(15,0)"
      />
    </svg>
  );
};
